import React from "react";
import { SiNextdotjs } from "react-icons/si";
import C from "../../Assets/TechIcons/C.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Java from "../../Assets/TechIcons/Java.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Firebase from "../../Assets/TechIcons/Firebase.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import Mongo from "../../Assets/TechIcons/Mongo.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import MUI from "../../Assets/TechIcons/MUI.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import AWS from "../../Assets/TechIcons/AWS.svg";
import Supabase from "../../Assets/TechIcons/Supabase.svg";

const skills = [
  { name: "C", src: C },
  { name: "Javascript", src: Javascript },
  { name: "Typescript", src: Typescript },
  // { name: "Go", src: Go },
  { name: "Node.Js", src: Node },
  { name: "React.Js", src: ReactIcon },
  // { name: "Solidity", icon: SiSolidity },
  { name: "Mongo DB", src: Mongo },
  // { name: "Redux", src: Redux },
  { name: "Next.js", icon: SiNextdotjs },
  { name: "Git", src: Git },
  { name: "Firebase", src: Firebase },
  { name: "Supabase", src: Supabase },
  // { name: "Redis", src: Redis },
  { name: "Docker", src: Docker },
  // { name: "Kubernetes", src: Kubernates },
  { name: "Postgresql", src: SQL },
  { name: "Python", src: Python },
  { name: "Java", src: Java },
  // { name: "Haskell", src: HaskellIcon },
  { name: "Tailwind CSS", src: Tailwind },
  { name: "Material UI", src: MUI },
  { name: "Postman", src: Postman },
  // { name: "Rust", icon: FaRust },
  { name: "AWS", src: AWS },
  // { name: "Kafka", src: Kafka },
];

function SkillCard({ skill }) {
  const IconComponent = skill.icon;

  return (
    <div className="skill-carousel-item">
      <div className="skill-icon-card">
        {skill.src ? (
          <img src={skill.src} alt={skill.name} />
        ) : (
          <IconComponent className="skill-carousel-icon" />
        )}
      </div>
      <span className="skill-carousel-label">{skill.name}</span>
    </div>
  );
}

function Techstack() {
  const carouselSkills = [...skills, ...skills];

  return (
    <div className="carousel-wrapper skill-carousel-section">
      <div className="carousel-track">
        {carouselSkills.map((skill, index) => (
          <SkillCard key={`${skill.name}-${index}`} skill={skill} />
        ))}
      </div>
    </div>
  );
}

export default Techstack;
